import {
  arbitrum,
  bsc,
  bscTestnet,
  fantom,
  linea,
  mainnet,
  okc,
  opBNB,
  polygon,
  base,
  avalanche,
  sepolia,
} from '@wagmi/core/chains';
import { Chain, defineChain } from 'viem';
import { fallback, http, unstable_connector } from '@wagmi/core';
import { injected } from '@wagmi/connectors';

import { inEVM } from './customChains';

const polygonWithCustomRPC = {
  ...polygon,
  rpcUrls: {
    default: {
      http: ['https://rpc-mainnet.matic.quiknode.pro/'],
    },
  },
};

const lumia = defineChain({
  id: 994873017,
  name: 'Lumia',
  nativeCurrency: {
    decimals: 18,
    name: 'Lumia',
    symbol: 'LUMIA',
  },
  rpcUrls: {
    default: { http: ['https://mainnet-rpc.lumia.org/'] },
  },
  blockExplorers: {
    default: {
      name: 'Blockscout',
      url: 'https://explorer.lumia.org/',
      apiUrl: 'https://explorer.lumia.org/api',
    },
  },
});

const availableMainnetChains: readonly [Chain, ...Chain[]] = [
  mainnet,
  bsc,
  okc,
  polygonWithCustomRPC,
  fantom,
  arbitrum,
  linea,
  opBNB,
  inEVM,
  base,
  avalanche,
  lumia,
];

const lumiaTestnet = defineChain({
  id: 1952959480,
  name: 'Lumia L2 Testnet',
  nativeCurrency: {
    decimals: 18,
    name: 'Lumia',
    symbol: 'LUMIA',
  },
  rpcUrls: {
    default: { http: ['https://testnet-rpc.lumia.org/'] },
  },
  blockExplorers: {
    default: {
      name: 'Blockscout',
      url: 'https://testnet-explorer.lumia.org/',
      apiUrl: 'https://testnet-explorer.lumia.org/api',
    },
  },
});

const availableTestnetChains: readonly [Chain, ...Chain[]] = [
  bscTestnet,
  sepolia,
  lumiaTestnet,
];

// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
export const availableChains = [
  ...availableMainnetChains,
  ...availableTestnetChains,
] as [Chain, ...Chain[]];

export const transports = availableChains.reduce(
  (prevVal, nextChain) => ({
    ...prevVal,
    [nextChain.id]: fallback([unstable_connector(injected), http()]),
  }),
  {},
);
